(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fzf-lead-popup"]) return;
  try {
    
  if (!customElements.get('fzf-lead-popup')) {
    customElements.define('fzf-lead-popup', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;

        this.sessionKey = 'fzfLeadPopupShown';
        this.dismissKey = 'fzfLeadPopupDismissedAt';
        this.subscribedKey = 'fzfLeadPopupSubscribed';
        this.isSuccess = this.dataset.success === 'true' || Boolean(this.querySelector('[data-fzf-success]'));

        this.addEventListener('submit', () => {
          localStorage.setItem(this.subscribedKey, 'true');
        });

        this.querySelectorAll('[data-fzf-close]').forEach((button) => {
          button.addEventListener('click', () => this.close(true));
        });

        this.dialog.addEventListener('click', (event) => {
          const rect = this.dialog.getBoundingClientRect();
          const inside = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
          if (!inside) this.close(true);
        });

        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.close(true);
        });

        if (Shopify.designMode) {
          this.open();
          document.addEventListener('shopify:section:select', (event) => {
            if (event.target.contains(this)) this.open();
          });
          return;
        }

        if (this.isSuccess) {
          localStorage.setItem(this.subscribedKey, 'true');
          sessionStorage.removeItem(this.sessionKey);
          this.open();
          return;
        }

        if (localStorage.getItem(this.subscribedKey) === 'true' || sessionStorage.getItem(this.sessionKey) === 'true' || this.wasRecentlyDismissed()) return;

        this.onScroll = this.handleScroll.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.handleScroll();

        if (this.dataset.exitIntent === 'true' && window.matchMedia('(min-width: 990px)').matches) {
          this.onMouseOut = (event) => {
            if (event.clientY <= 0 && !event.relatedTarget) this.open();
          };
          document.addEventListener('mouseout', this.onMouseOut);
        }
      }

      wasRecentlyDismissed() {
        const dismissedAt = Number(localStorage.getItem(this.dismissKey) || 0);
        const days = Number(this.dataset.dismissDays || 7);
        return Date.now() - dismissedAt < days * 86400000;
      }

      handleScroll() {
        const scrollable = document.documentElement.scrollHeight - window.innerHeight;
        if (scrollable <= 0) return;
        const progress = (window.scrollY / scrollable) * 100;
        if (progress >= Number(this.dataset.scrollPercent || 40)) this.open();
      }

      open() {
        if (this.dialog.open) return;
        if (!Shopify.designMode && !this.isSuccess) sessionStorage.setItem(this.sessionKey, 'true');
        this.dialog.showModal();
        this.removeTriggers();
        const focusTarget = this.querySelector('input, [data-fzf-success]');
        if (focusTarget) requestAnimationFrame(() => focusTarget.focus());
      }

      close(remember) {
        if (remember && !this.isSuccess && !Shopify.designMode) localStorage.setItem(this.dismissKey, String(Date.now()));
        this.dialog.close();
      }

      removeTriggers() {
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
        if (this.onMouseOut) document.removeEventListener('mouseout', this.onMouseOut);
      }

      disconnectedCallback() {
        this.removeTriggers();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
